import { render, staticRenderFns } from "./CourseInfo.vue?vue&type=template&id=4f61265e&scoped=true"
import script from "./CourseInfo.vue?vue&type=script&lang=js"
export * from "./CourseInfo.vue?vue&type=script&lang=js"
import style0 from "./CourseInfo.vue?vue&type=style&index=0&id=4f61265e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f61265e",
  null
  
)

export default component.exports